export const LONG_LEAD_TIME_THRESHOLD = 14; // days
export const LOW_STOCK_THRESHOLD = 5;
export const MAX_NEGOTIATED_LEADTIME_DAYS = 2;
export const LEAD_TIME_CUSHION_DAYS = 2;
export const LEAD_TIME_EXTRA_CUSHION_DAYS = 7;
export const LEAD_TIME_CONTACT_JBT_THRESHOLD = 45;
